var React = require('react');

function Shape3 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M75.8295 0L75.1705 2.12619V0C33.6481 0 0 23.2064 0 79.0145V108.727V135.986V140.62H0.0867536C1.90791 193.084 34.8275 215 75.1705 215V213.037L75.8295 215C116.19 215 149.092 193.066 150.913 140.62H151V135.986V108.745V79.0145C151 23.2064 117.352 0 75.8295 0Z"}));
}

Shape3.defaultProps = {"width":"151","height":"215","viewBox":"0 0 151 215","fill":"none"};

module.exports = Shape3;

Shape3.default = Shape3;
